import {
    EonUiDropdown,
    EonUiDropdownOption,
} from "@eon-ui/eon-ui-components-react";
import type { Persona } from "../aidwops.types";
import { EonUiDropdownCustomEvent } from "@eon-ui/eon-ui-components";

export type QueueRole = "engineer" | "iso";
export type QueueStatusFilter = "pending" | "decided" | "all";

interface ExpertQueueFiltersProps {
    role: QueueRole;
    onRoleChange: (role: QueueRole) => void;
    persona: Persona;
    onPersonaChange: (persona: Persona) => void;
    status: QueueStatusFilter;
    onStatusChange: (status: QueueStatusFilter) => void;
}

/**
 * Replaces the old persona-rail entries for the Intune queue, ISO queue, and Recents: one Role choice, an
 * engineer-only Persona choice, and a Status choice, all driving the same Expert Queue view.
 */
export function ExpertQueueFilters({
    role,
    onRoleChange,
    persona,
    onPersonaChange,
    status,
    onStatusChange,
}: ExpertQueueFiltersProps) {
    return (
        <div className="expert-queue-filters">
            <EonUiDropdown
                onValueChanged={(e: EonUiDropdownCustomEvent<string>) => {
                    onRoleChange(e.target.value as QueueRole);
                }}
                value={role}
                key={"role-" + role}
                name="role"
                size="small"
                label="Role"
                style={{ minWidth: "150px", width: "20%" }}
            >
                <EonUiDropdownOption
                    key={"engineer"}
                    value="engineer"
                    label="Engineer"
                />
                <EonUiDropdownOption key={"iso"} value="iso" label="ISO" />
            </EonUiDropdown>
            {role === "engineer" && (
                <EonUiDropdown
                    onValueChanged={(e: EonUiDropdownCustomEvent<string>) => {
                        onPersonaChange(e.target.value as Persona);
                    }}
                    value={persona}
                    key={"persona-" + persona}
                    name="persona"
                    size="small"
                    label="Product"
                    style={{ minWidth: "150px", width: "20%" }}
                >
                    <EonUiDropdownOption key={"all"} value="all" label="All" />
                    <EonUiDropdownOption
                        key={"zscaler"}
                        value="zscaler"
                        label="Zscaler"
                    />
                    <EonUiDropdownOption
                        key={"intune"}
                        value="intune"
                        label="Intune"
                    />
                </EonUiDropdown>
            )}
            <EonUiDropdown
                onValueChanged={(e: EonUiDropdownCustomEvent<string>) => {
                    onStatusChange(e.target.value as QueueStatusFilter);
                }}
                value={status}
                key={"status-" + status}
                name="status"
                size="small"
                label="Status"
                style={{ minWidth: "150px", width: "20%" }}
            >
                <EonUiDropdownOption
                    key={"pending"}
                    value="pending"
                    label="Pending"
                />
                <EonUiDropdownOption
                    key={"decided"}
                    value="decided"
                    label="Decided"
                />
                <EonUiDropdownOption key={"all"} value="all" label="All" />
            </EonUiDropdown>
        </div>
    );
}
